module.exports = __webpack_public_path__ + "img/letpay.bb77e93b.png";